import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  FetchDashboardDataFailure,
  FetchDashboardDataRequest,
  FetchDashboardDataSuccess,
  FetchDashboardsFailure,
  FetchDashboardsRequest,
  FetchDashboardsSuccess,
} from './map-analytics.actions'
import { MapAnalyticsService } from './map-analytics.service'
import * as IndustriesTypes from './map-analytics.types'

@Injectable()
export class MapAnalyticsEffects {
  constructor(
    private actions: Actions,
    private mapAnalyticsService: MapAnalyticsService,
    private router: Router,
  ) {}

  FetchDashboards$ = createEffect(() =>
    this.actions.pipe(
      ofType(IndustriesTypes.FETCH_DASHBOARDS_REQUEST),
      switchMap((action: FetchDashboardsRequest) => {
        return this.mapAnalyticsService.fetchDashboards().pipe(
          map((result) => {
            return new FetchDashboardsSuccess(result.data.dashboards)
          }),
          catchError((err, caught) => {
            return of(new FetchDashboardsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchDashboardData$ = createEffect(() =>
    this.actions.pipe(
      ofType(IndustriesTypes.FETCH_DASHBOARD_DATA_REQUEST),
      switchMap((action: FetchDashboardDataRequest) => {
        return this.mapAnalyticsService
          .fetchDashboardData(action.key, action.payload)
          .pipe(
            map((result) => {
              return new FetchDashboardDataSuccess(result.data.results)
            }),
            catchError((err, caught) => {
              return of(new FetchDashboardDataFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
